"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.randomString = randomString;
exports.splitFilename = splitFilename;

function randomString() {
  return Math.random().toString(36).substr(2, 6);
}

function splitFilename(fileName) {
  var fileExtension = fileName.split(".").slice().pop();
  var nameWithoutExtension = fileName.split(".").slice(-1).join(".");
  return {
    fileExtension: fileExtension,
    nameWithoutExtension: nameWithoutExtension
  };
}